module.exports = {"330683001":"剡湖街道","330683002":"三江街道","330683003":"鹿山街道","330683005":"浦口街道","330683100":"甘霖镇","330683101":"长乐镇","330683102":"崇仁镇","330683103":"黄泽镇","330683104":"三界镇","330683105":"石璜镇","330683106":"谷来镇","330683107":"仙岩镇","330683108":"金庭镇","330683110":"下王镇","330683200":"贵门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330683.json
// module id = 1099
// module chunks = 0